import * as Cookies from "es-cookie"

export const DLogout = async () => {
  const dcmRetUrl = Cookies.get("dcmRetUrl")
  Cookies.remove("JWToken")
  Cookies.remove("dcmRetUrl")
  const daccountEndpoint = process.env.REACT_APP_DLOGOUT_ENDPOINT
  const nl = encodeURIComponent(
    dcmRetUrl || process.env.REACT_APP_DLOGOUT_DHOME
  )
  const logoutRequest = `${daccountEndpoint}?serviceurl=${nl}`

  window.location.href = logoutRequest
}
